import React, { useContext, useMemo } from "react";
import { useShowAllZones } from "./use-show-all-zones";

const ShowAllZonesContext = React.createContext(undefined);

export const useShowingAllZones = () => {
	const context = useContext(ShowAllZonesContext);

	if (context === undefined) {
		console.error(
			"[INTERACTIVE-PRODUCTS] useShowAllZonesContext must be used within a ShowAllZonesProvider"
		);
	}

	return context;
};

export const ShowAllZonesProvider = ({ children }) => {
	const { showingAllZones } = useShowAllZones();

	const contextMemoized = useMemo(
		() => ({
			showingAllZones,
		}),
		[showingAllZones]
	);

	return (
		<ShowAllZonesContext.Provider value={contextMemoized}>
			{children}
		</ShowAllZonesContext.Provider>
	);
};
